import { TabItem } from '@components/ui/tabs';
import { useRouter } from 'next/router';
import { tabQueryKey } from 'src/constant';
import { findIndex, get } from 'lodash';

export type GetActiveTabFromRouter = {
  tabs: TabItem[];
  routerKey?: string;
  defaultTab?: number;
};

export const useGetActiveTabFromRouter = ({
  tabs,
  routerKey = tabQueryKey,
  defaultTab = 0,
}: GetActiveTabFromRouter) => {
  let result = defaultTab;
  const { query } = useRouter();
  const currentTab = get(query, `${routerKey}[0]`);

  if (currentTab) {
    result = findIndex(tabs, (tab) => tab.id === currentTab);
  }
  return result === -1 ? defaultTab : result;
};
